// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1L_Ca","emails":"CreateEditClinics_emails__3nLvv","emailTagLabel":"CreateEditClinics_emailTagLabel__3WwpB"};